<mat-toolbar class="headerlogin">
    <div class="headerlogin_app-name">
        <label>{{'name-app' | translate }}{{envLabel}}</label>
    </div>
    <div class="headerlogin_info">
        <div class="headerlogin_logo">
            <img src="./assets/images/components/logoSchaeffler.svg">
        </div>
    </div>
</mat-toolbar>